<template>
  <div>
    <h2 class="my-5">
      <b>What type of digital evidence you want to process?</b>
    </h2>
    <div class="py-5 mt-5">
      <button class="btn border mr-5 selection-btn" @click="selector(1)">
        <img src="../assets/images/world.svg" />Web contents
      </button>
      <button class="btn border selection-btn" @click="selector(2)">
        <img src="../assets/images/file.svg" /> Local documents
      </button>
    </div>

    <div class="d-flex pt-5 steps-button invisible">
      <button class="btn back-btn ml-0 mr-auto" @click="nextHandler(0)" disabled>
        <i class="fa fa-angle-left mr-2" /> Back
      </button>
      <button class="btn next-btn ml-auto mr-0" @click="nextHandler(1)" :disabled="!isStepComplete">
        Next <i class="fa fa-angle-right ml-2" />
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "TypeSelection",
  props: {
    nextHandler: Function,
    typeSelectionCB: Function,
  },
  data() {
    return {
      isStepComplete: false,
    }
  },
  methods: {
    selector(mode) {
      this.isStepComplete = true
      this.typeSelectionCB(mode)
      this.nextHandler(1)
    },
  },
}
</script>
<style scoped>
.selection-btn {
  line-height: 60px;
  color: var(--font-color-primary);
  border-radius: 10px;
  padding: 10px 20px;
  font-weight: 500;
  text-transform: uppercase;
}

.selection-btn img {
  width: 30px;
  margin-right: 20px;
}

.selection-btn:focus,
.selection-btn:active {
  outline: none;
  border: none;
}

@media screen and (max-width: 600px) {
  .selection-btn {
    width: 100%;
    margin-bottom: 20px;
    margin-right: 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TypeSelection.vue